import DataOriginParameterModel from '../models/DataOriginParameterModel';
import BaseStore from './BaseStore';

class DataOriginParameterStore extends BaseStore {
  stationStore;

  constructor(transportLayer, stationStore) {
    super(DataOriginParameterModel, transportLayer);
    this.stationStore = stationStore;
  }
}

export default DataOriginParameterStore;



// WEBPACK FOOTER //
// ./src/stores/DataOriginParameterStore.js